import React, {useEffect} from 'react';
import '../styles/Pages.css';

const Cerej = () => {
    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/209dcc199429495.66590cada940b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/342481199429495.665a721078a52.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/8d1ca7199429495.66590cada9b10.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/781dcb199429495.66512b5d592a5.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/250db1199429495.66590cada8c91.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/336785199429495.665bcc3f9c01b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/2a9ec5199429495.668206bf278fc.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/b348a5199429495.667b55ee9c9bc.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/c14e04199429495.665227ec110e8.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/c306b6199429495.668206bf26af7.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/ff2417199429495.667b6b693e8f0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3f5e89199429495.6680d899f0794.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/9b636e199429495.668206bf27f8d.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/37f541199429495.668206bf2722b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/d2211e199429495.667a2345a34d7.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/339b8a199429495.6680d899f0f9d.jpg'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };

      }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Cerej</h1>
                    <p className="subtitle">A Cerej é uma agência de comunicação que une criatividade e emoção para criar experiências visuais únicas.</p>
                </div>
                <div className="pages-right">
                    <p className="description">
                        O nome "Cerej" foi inspirado na Cereja, uma fruta que desperta os sentidos com seu sabor marcante e refrescante. A missão da Cerej é criar projetos que sejam memoráveis e impactantes, destacando-se pela originalidade e pela capacidade de tocar o público de forma profunda, sendo a Cereja do bolo para a comunicação.
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Cerej Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default Cerej;
